<template>
  <v-card flat>
    <v-card-text>
      <template v-if="!local.id">
        <v-row
          justify="center"
          align="center"
        >
          <span class="reg-text">User profile not found</span>
        </v-row>
      </template>
      <template v-else>
        <v-row>
          <v-col cols="4">
            <base-app-number-field
              v-model="local.id"
              label="User ID"
              disabled
            />
          </v-col>
          <v-col cols="4">
            <base-app-text-field
              v-model="local.uuid"
              label="User UUID"
              disabled
            />
          </v-col>
          <v-col cols="4">
            <base-app-number-field
              v-model="local.state"
              label="state"
              disabled
            />
          </v-col>
          <v-col cols="4">
            <base-app-text-field
              v-model="local.username"
              label="Username"
              disabled
            />
          </v-col>
          <v-col cols="4">
            <base-app-text-field
              v-model="local.firstName"
              label="First name"
              disabled
            />
          </v-col>
          <v-col cols="4">
            <base-app-text-field
              v-model="local.lastName"
              label="Last name"
              disabled
            />
          </v-col>
          <v-col cols="4">
            <base-app-text-field
              :value="formatDate(local.created, 'YYYY-MM-DD HH:mm:ss')"
              label="Created"
              disabled
            />
          </v-col>
          <v-col cols="4">
            <base-app-text-field
              :value="formatDate(local.lastModified, 'YYYY-MM-DD HH:mm:ss')"
              label="lastModified"
              disabled
            />
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
  import moment from 'moment'

  export default {
    name: 'UserProfileTab',
    props: {
      value: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      local: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('update:value', value)
        },
      },
    },
    watch: {
      local: () => {
      },
    },
    methods: {
      formatDate (value, format) {
        if (value) {
          return moment(value).format(format)
        }
        return ''
      },
    },
  }
</script>

<style scoped>
.reg-text {
  color: grey
}
</style>
